'use client';

import NutrientGroupTitle from '@/components/NutrientGroupTitle';
import LinkLocalized from '@/components/nav/LinkLocalized';
import { nutrientI18n } from '@/i18n/en/nutrient.i18n';
import {
  FoodNutrient as NutrientType,
  NutrientGroupId,
} from '@/types/Nutrient.types';
import { useState } from 'react';
import Nutrient from '@/components/Nutrient';
import {
  nutrientGroupEmoji,
  nutrientGroupI18n,
} from '@/i18n/en/nutrient-group.i18n';

type Props = {
  nutrients: NutrientType[];
  nutrientGroup: NutrientGroupId | 'top';
};

export default function NutrientGroup({ nutrients, nutrientGroup }: Props) {
  const [showAll, setShowAll] = useState(true);

  const title =
    nutrientGroup === 'top'
      ? '🏆 Top 5'
      : nutrientGroupEmoji[nutrientGroup] +
        ' ' +
        nutrientGroupI18n[nutrientGroup];

  return (
    <div className="">
      <NutrientGroupTitle title={title} onClick={() => setShowAll(!showAll)} />

      {showAll ? (
        <div className="">
          {nutrients.map(({ id, quantity, ranking, unit }) => (
            <LinkLocalized
              className="clickable ml-0 flex pb-0 md:px-1"
              key={id}
              href={`/nutrient/${id}`}
            >
              <Nutrient
                name={nutrientI18n[id]}
                nameSize="base"
                quantity={quantity}
                ranking={ranking}
                unit={unit}
              />
            </LinkLocalized>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
